// removed by extract-text-webpack-plugin
module.exports = {"root":"_2EkmdQ7ZthGHe4sTEclyCv","content":"_3dIIO-erTjVnCAGIuvTH7F","decor":"_2xm3HRTdIO3XWMXpw1LkyU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/styles.css
// module id = 1055
// module chunks = 0